import Cookies from 'js-cookie'

Promise.all([import('./subscription-pop-up.scss')]).then(() => {

  $('.widget.subscription-pop-up').each(function (i, el) {
    $(el).data('widget', new SubscriptionPopUp(el))
    $(el).data('widget').init()
  })
})

function SubscriptionPopUp(el) {
  const self = this
  self.el = $(el)
  self.uid = `SubscriptionPopUp`
  self.modal = self.el.find('.ui.modal')

  self.hasReachedAppearanceLimit = function () {
    const appearanceCount = parseInt(Cookies.get(`SubscriptionPopUpAppearanceCount`))
    return appearanceCount >= 1
  }

  self.close = function () {
    let appearanceCount = parseInt(Cookies.get(`SubscriptionPopUpAppearanceCount`))
    appearanceCount > 0 ? appearanceCount++ : (appearanceCount = 1)

    Cookies.set(`SubscriptionPopUpAppearanceCount`, 1, {
      expires: 365, // in days
      path: '/',
    })

    self.modal.modal('hide')
  }

  self.setupPopup = () => {
    self.modal.find('.close.icon').click(function (event) {
      event.preventDefault()
      self.close()
    })

    self.modal.find('.subscription-btn.js-modal-cta-link').click(function (event) {
      //event.preventDefault()
      self.close()
    })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('SubscriptionPopUp init', self)
    }

    // Check if we should show the modal on page load
    if (self.hasReachedAppearanceLimit()) return


    // If the user has not accepted GDPR, we want to wait for them to action that before initializing the rest of the popup


    var hasAcceptedGDPR = window.dbs.utilities.getLocalStorageWithExpiry('gdprConsentAccepted');
    if (!hasAcceptedGDPR) {
      window.dbs.globalEvents.subscribe('gdprAccepted', function (data) {
        self.setupPopup();
        self.setupEventsAndTimers();
      });
    } else {
      self.setupPopup();
      self.setupEventsAndTimers();
    }
  }

  self.setupEventsAndTimers = () => {
    // Set the threshold in pixels
    const scrollThreshold = 1000;
    // Flag to ensure the action only happens once
    let thresholdReached = false;

    const searchInput = $('.search-form-container input[name="location"]')
    let popupTimer;

    // Add focus event listener to remove the delayed popup
    searchInput.on('focus', () => {
      console.log('Input field focused!');
      if (popupTimer) {
        clearTimeout(popupTimer);
        popupTimer = null;
      }
    });

    // Scroll listener, if the user scrolls past the threshhold, show it
    window.addEventListener('scroll', () => {
      // If we haven't reached threshold yet and now we have
      if (!thresholdReached && window.scrollY >= scrollThreshold) {
        thresholdReached = true;

        if (self.hasReachedAppearanceLimit()) {
          return;
        }

        clearTimeout(popupTimer); // clear timed popup
        self.modal
          .modal({
            closable: false,
          })
          .modal('show')

      }
    });

    let waitTimer = parseInt($('.widget.subscription-pop-up').attr('data-wait-timer')) || false
    if (waitTimer) {
      popupTimer = setTimeout(function () {
        if (self.hasReachedAppearanceLimit()) {
          return;
        }
        self.modal
          .modal({
            closable: false,
          })
          .modal('show');
      }, waitTimer * 1000) // * 1000 for seconds
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.warn('No wait timer found!')
      }
    }
  }
}
